enum Homepage {
  url = 'https://info.manslauks.lv',
}

export default Homepage;
